import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '~/app/rootReducer';

const selectActivationProgressState = (state: RootState) =>
  state.activationProgress;

/** All currently tracked activation batches (one row per batch). */
export const selectActiveActivationBatches = createSelector(
  [selectActivationProgressState],
  (activationProgress) => activationProgress.batches
);

/**
 * Timestamp of the last batch completion. Device lists subscribe to this to
 * refetch once activation finishes.
 */
export const selectLastActivationCompletedAt = createSelector(
  [selectActivationProgressState],
  (activationProgress) => activationProgress.lastCompletedAt
);
